import { useOutletContext } from 'react-router-dom';
import { EmployeeCostReport } from '@/components/employees/EmployeeCostReport';
import type { AppShellContext } from '@/components/layout/AppShell';

export function EmployeeCostReportPage() {
  const { nip, companyName } = useOutletContext<AppShellContext>();
  return <EmployeeCostReport companyNip={nip} companyName={companyName} />;
}
